import React, { Component, Suspense } from 'react'
import { HashRouter, BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'

import { ReactNotifications } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

// import { SSEGlobalProvider, SSEContext } from './utils/sseGlobalContext'
import { SSEProvider } from './utils/SSEContext'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const ZoneLayout = React.lazy(() => import('./layout/ZoneLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <>
        <ReactNotifications />
        <SSEProvider>
          <BrowserRouter>
            <Suspense fallback={loading}>
              <Routes>
                <Route
                  exact
                  path="/"
                  name="Dashboard"
                  element={<Navigate to="/dashboard" replace={true} />}
                />
                <Route exact path="/login" name="Login Page" element={<Login />} />
                <Route exact path="/register" name="Register Page" element={<Register />} />
                <Route exact path="/404" name="Page 404" element={<Page404 />} />
                <Route exact path="/500" name="Page 500" element={<Page500 />} />
                <Route exact path="/work-queue/zone*" name="Zoning" element={<ZoneLayout />} />
                {/* <Route path="*" name="Zoning" element={<ZoneLayout />} /> */}
                <Route path="*" name="Dashboard" element={<DefaultLayout />} />
                {/* <Redirect to="/dashboard" from="/" /> */}
              </Routes>
            </Suspense>
          </BrowserRouter>
        </SSEProvider>
      </>
    )
  }
}

export default App
